<template>
  <div class="finalWrapper">
    <template v-if="advanta">
      <div class="redeeming">Success!</div>
      <div class="redeeming2">Your NEOU account has been set up and linked to ActiveFit, please continue below:</div>
      <a href="activefit://neouredirect" class="neouButton">Close and Continue</a>
    </template>
    <template v-else>
      <md-progress-spinner md-mode="indeterminate" :md-diameter="50" :md-stroke="3"></md-progress-spinner>
      <div class="redeeming">Success!...</div>
      <div class="redeeming2">Redirecting you to NEOU</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Final",
  data: () => ({
    advanta: false
  }),
  beforeMount: function() {
    document.cookie = "authToken=" + this.$cookie.get("getUserToken") + ";domain=.neoufitness.com;path=/"
    if( "partner" in window && window.partner == "advanta" ) {
      this.advanta = true;
    } else {
      setTimeout(() => {
        window.location.href = "https://app.neoufitness.com/onboard-profile";
      }, 4500);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.finalWrapper {
  text-align: center;
  margin-top: 25vh;
}
.redeeming {
  font-size: 24px;
  font-weight: 500;
  margin: 20px 0px;
}
.redeeming2 {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 0px 25px;
  max-width:300px;
}
.md-progress-spinner {
  stroke: #56fffe;
}
.neouButton{
  padding:15px 40px;
  color:#000000;
  margin-top:40px;
  display:inline;

  &:hover{
    text-decoration:none;
  }
}

.light{
  .md-progress-spinner {
    stroke: #000000;
  }

  .redeeming,
  .redeeming2{
    color:#000000;
  }
}
</style>
